export default {
    "en": {
        "(and {count} more error)": "(and {count} more error)",
        "(and {count} more errors)": "(and {count} more errors)",
        "404 - Page not found": "404 - Page not found",
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{count} characters": "{count} characters",
        "About us": "About us",
        "Active": "Active",
        "Activities": "Activities",
        "Activity": "Activity",
        "Activity categories": "Activity categories",
        "ActivityCategory": "ActivityCategory",
        "ActivityCategory Settings": "ActivityCategory Settings",
        "Activity Settings": "Activity Settings",
        "Add": "Add",
        "Add extra": "Add extra",
        "Add frequently asked question": "Add frequently asked question",
        "Addition": "Addition",
        "Add link": "Add link",
        "Add page block": "Add page block",
        "Add plan": "Add plan",
        "After 30 days it is necessary to activate the two-step verification again": "After 30 days it is necessary to activate the two-step verification again",
        "All blogs": "All blogs",
        "All frequently asked questions": "All frequently asked questions",
        "All questions": "All questions",
        "All rights reserved.": "All rights reserved.",
        "Amount": "Amount",
        "Amount of activities": "Amount of activities",
        "Amount of products": "Amount of products",
        "Amount of videos": "Amount of videos",
        "Answer": "Answer",
        "A piece": "A piece",
        "Apply discount code": "Apply discount code",
        "Author": "Author",
        "Avatar": "Avatar",
        "Back": "Back",
        "Background color": "Background color",
        "Back to home": "Back to home",
        "Banner": "Banner",
        "Billing address": "Billing address",
        "Blog": "Blog",
        "Blog cta": "Blog cta",
        "Blog overview": "Blog overview",
        "Blogs": "Blog",
        "Blog Settings": "Blog Settings",
        "Button link": "Button link",
        "Buttons": "Buttons",
        "Button text": "Button text",
        "Capacities": "Capacities",
        "Capacity": "Capacity",
        "Categories": "Categorieën",
        "Category": "Category",
        "Category Settings": "Category settings",
        "Change": "Change",
        "Checkout": "Checkout",
        "City": "City",
        "Code": "Code",
        "Company details": "Bedrijfsinstellingen",
        "Company name": "Company name",
        "Complete": "Complete",
        "Completed": "Completed",
        "Concept": "Concept",
        "Concept in only visible to logged in users, draft is not visible to anyone": "Concept in only visible to logged in users, draft is not visible to anyone",
        "Confirmation {source}": "Confirmation {source}",
        "Confirm password": "Confirm password",
        "Contact": "Contact",
        "Contact Form": "Contact Form",
        "Contacts": "Contacten",
        "Content": "Content",
        "Coupon applied": "Coupon applied",
        "Coupon can no longer be used": "Coupon can no longer be used",
        "Coupon not found": "Coupon not found",
        "Coupons": "Kortingscodes",
        "Created at": "Created at",
        "Create your Fair To Horses account": "Create your Fair To Horses account",
        "CTA Banner": "CTA Banner",
        "Custom": "Custom",
        "Custom video preview": "Custom video preview",
        "Delete": "Delete",
        "Description": "Description",
        "description": "description",
        "Discount": "Discount",
        "Discount active": "Discount active",
        "Discount code": "Discount code",
        "Discount key": "Discount key",
        "Down": "Down",
        "Draft": "Draft",
        "E-mail": "E-mail",
        "Email": "Email",
        "Email address": "Email address",
        "End": "End",
        "End date": "End date",
        "Enter one of the recovery codes here": "Enter one of the recovery codes here",
        "Enter the 6-digit code here": "Enter the 6-digit code here",
        "Excerpt": "Excerpt",
        "excerpt": "excerpt",
        "Extra bookings": "Extra bookings",
        "Extra opties": "Extra opties",
        "Extra options": "Extra options",
        "Extras": "Extras",
        "Extras description": "Extras description",
        "Extras title": "Extras title",
        "Faq": "Faq",
        "Faq Index": "Faq Index",
        "Faqs": "Faqs",
        "Features": "Features",
        "Filter": "Filter",
        "First name": "First name",
        "Forbidden": "Forbidden",
        "Forgot password": "Forgot password",
        "Forgot password?": "Forgot password?",
        "Forgot your password? Send a password reset link": "Forgot your password? Send a password reset link",
        "Function": "Function",
        "Gallery": "Gallery",
        "General": "General",
        "Generic": "Generic",
        "Google Maps URL": "Google Maps URL",
        "Google maps URL": "Google maps URL",
        "Go to page {page}": "Go to page {page}",
        "Hello!": "Hello!",
        "Highlighted pages": "Highlighted pages",
        "Hits": "Hits",
        "Home Banner": "Home Banner",
        "Horse": "Horse",
        "Horse categories": "Horse categories",
        "HorseCategory": "HorseCategory",
        "HorseCategory Settings": "HorseCategory Settings",
        "Horses": "Horses",
        "Horse Settings": "Horse Settings",
        "I agree with the terms and conditions and have checked my order and details *": "I agree with the terms and conditions and have checked my order and details *",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "If enabled, and no image is uploaded, the banner from the homepage will be shown.",
        "If left empty, the page title will be used.": "If left empty, the page title will be used.",
        "If left empty, the title will be used.": "If left empty, the title will be used.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:",
        "If you did not create an account, no further action is required.": "If you did not create an account, no further action is required.",
        "If you did not request a password reset, no further action is required.": "If you did not request a password reset, no further action is required.",
        "I have a discount": "I have a discount",
        "Image": "Image",
        "Image + Text": "Image + Text",
        "Image left": "Image left",
        "Image right": "Image right",
        "Including VAT": "Including VAT",
        "Index Page": "Index Page",
        "Initial": "Initial",
        "Introduction": "Introduction",
        "Invoice address (Optional)": "Invoice address (Optional)",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "It is recommended to keep the {attribute} between {min} and {max} characters long",
        "I would like to receive a newsletter from Fair to Horses.": "I would like to receive a newsletter from Fair to Horses.",
        "Last name": "Last name",
        "Latest orders": "Latest orders",
        "Layout": "Layout",
        "Leave empty for no end date": "Leave empty for no end date",
        "Leave empty to use parent details": "Leave empty to use parent details",
        "Link list": "Link list",
        "Login": "Login",
        "Login to checkout": "Login to checkout",
        "Login to your account in our secure environment": "Login to your account in our secure environment",
        "Logout": "Logout",
        "Made by:": "Made by:",
        "Make your decision:": "Make your decision:",
        "Message": "Message",
        "More settings can be set in the Page Block Settings page": "More settings can be set in the Page Block Settings page",
        "Name": "name",
        "name": "name",
        "Newsletter": "Newsletter",
        "New URL": "New URL",
        "Next": "Next",
        "No products in shopping cart": "No products in shopping cart",
        "Not available in this combination": "Not available in this combination",
        "Not Found": "Not Found",
        "Number": "Number",
        "of": "of",
        "Old URL": "Old URL",
        "Openings hours": "Openings hours",
        "Open the authenticator app on your phone and enter the code here": "Open the authenticator app on your phone and enter the code here",
        "Order": "Order",
        "Order now": "Order now",
        "Order number": "Order number",
        "Orders": "Bestellingen",
        "Overview": "Overview",
        "Package": "Package",
        "Page": "Page",
        "Page blocks": "Page blocks",
        "Page Content": "Page Content",
        "Page Expired": "Page Expired",
        "Pages": "Paginas",
        "Page Title": "Page Title",
        "Pagination Navigation": "Pagination Navigation",
        "Paid": "Paid",
        "paid": "Betaald",
        "Parent category": "Parent category",
        "Password": "Password",
        "Password reset": "Password reset",
        "Password reset link has been sent": "Password reset link has been sent",
        "Payment Required": "Payment Required",
        "Payments": "Payments",
        "People": "People",
        "Permanent": "Permanent",
        "Person": "Person",
        "Person categories": "Person categories",
        "PersonCategory": "PersonCategory",
        "PersonCategory Settings": "PersonCategory Settings",
        "Person Settings": "Person Settings",
        "Phone": "Phone",
        "Phone number": "Phone number",
        "Plans": "Plans",
        "Please click the button below to verify your email address.": "Please click the button below to verify your email address.",
        "Postal code": "Postal code",
        "Postalcode": "Postalcode",
        "Postcode": "Postcode",
        "Previous": "Previous",
        "Price": "Price",
        "Price annual": "Price annual",
        "Price annual monthly": "Price annual monthly",
        "Price half year": "Price half year",
        "Price half year monthly": "Price half year monthly",
        "Price yearly": "Price yearly",
        "Price yearly monthly": "Price yearly monthly",
        "Pricing header": "Pricing header",
        "Primary (dark green)": "Primary (dark green)",
        "Primary type": "Primary type",
        "Privacy declaration": "Privacy declaration",
        "Product": "Product",
        "Products": "Producten",
        "Published": "Published",
        "Published at": "Published at",
        "Published Date": "Published Date",
        "Quantity": "Quantity",
        "Question": "Question",
        "Read more": "Read more",
        "Regards": "Regards",
        "Register": "Register",
        "Register to your account in our secure environment": "Register to your account in our secure environment",
        "Remark": "Remark",
        "Remove discount code": "Remove discount code",
        "Reset Password": "Reset Password",
        "Reset password": "Reset password",
        "Reset Password Notification": "Reset Password Notification",
        "Reset your password": "Reset your password",
        "results": "results",
        "Roles": "Roles",
        "Same address": "Same address",
        "Scope": "Scope",
        "Secondary (beige)": "Secondary (beige)",
        "Secondary button link": "Secondary button link",
        "Secondary button text": "Secondary button text",
        "Secondary dark (brown)": "Secondary dark (brown)",
        "Secure video": "Secure video",
        "Select": "Select",
        "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created": "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created",
        "Send": "Send",
        "Send a password reset link": "Send a password reset link",
        "Send email": "Send email",
        "Send link": "Send link",
        "Sent at": "Sent at",
        "Seo Settings": "Seo Settings",
        "SEO title": "SEO title",
        "Server Error": "Server Error",
        "Services": "Services",
        "Service Unavailable": "Service Unavailable",
        "Setting": "Setting",
        "Settings": "Instellingen",
        "Shipping address": "Shipping address",
        "Shipping address same as billing address": "Shipping address same as billing address",
        "Shipping method": "Shipping method",
        "Shipping rates": "Verzendkosten",
        "Shop": "Shop",
        "Short title (1-2 words) for the thumbnail": "Short title (1-2 words) for the thumbnail",
        "Showing": "Showing",
        "Slug": "Slug",
        "Social media": "Social media",
        "Start": "Start",
        "Start date": "Start date",
        "Status": "Status",
        "Street name": "Street name",
        "Street number": "Street number",
        "Street number addition": "Street number addition",
        "Subject": "Subject",
        "Subtitle": "Subtitle",
        "Subtotal": "Subtotal",
        "Tags": "Tags",
        "Tax": "Tax",
        "Terms and Conditions": "Terms and Conditions",
        "Text": "Text",
        "Thank you for your message.": "Thank you for your message.",
        "The {attribute} must contain at least one letter.": "The {attribute} must contain at least one letter.",
        "The {attribute} must contain at least one number.": "The {attribute} must contain at least one number.",
        "The {attribute} must contain at least one symbol.": "The {attribute} must contain at least one symbol.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "The {attribute} must contain at least one uppercase and one lowercase letter.",
        "The coupon has already been used.": "The coupon has already been used.",
        "The coupon has expired.": "The coupon has expired.",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.",
        "The given data was invalid.": "The given data was invalid.",
        "The provided password does not match your current password.": "The provided password does not match your current password.",
        "This password reset link will expire in {count} minutes.": "This password reset link will expire in {count} minutes.",
        "Title": "Title",
        "title": "title",
        "Title override": "Title override",
        "to": "to",
        "Toggle navigation": "Toggle navigation",
        "Too Many Requests": "Too Many Requests",
        "Total": "Total",
        "Total quantity": "Total quantity",
        "Trainer": "Trainer",
        "Trainers": "Trainers",
        "Trainer Settings": "Trainer Settings",
        "Two factor challenge": "Two factor challenge",
        "Type": "Type",
        "Unauthorized": "Unauthorized",
        "Unavailable code": "Unavailable code",
        "Up": "Up",
        "Upcoming activities": "Upcoming activities",
        "url": "url",
        "Use an authentication code": "Use an authentication code",
        "Use a recovery code": "Use a recovery code",
        "User": "User",
        "Users": "Users",
        "Uw winkelmand is leeg": "Uw winkelmand is leeg",
        "Variant": "Variant",
        "Variants": "Variants",
        "VAT": "VAT",
        "Verify and login": "Verify and login",
        "Verify Email Address": "Verify Email Address",
        "Video": "Video",
        "Videos": "Videos",
        "Was unable to find an address with this postcode and street number": "Was unable to find an address with this postcode and street number",
        "Website": "Website",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "When enabled, an email will be sent to the user, letting them know their account has been created.",
        "White": "White",
        "Whoops!": "Whoops!",
        "You are receiving this email because we received a password reset request for your account.": "You are receiving this email because we received a password reset request for your account.",
        "Your account for {siteName}": "Your account for {siteName}",
        "Your cart is empty": "Your cart is empty",
        "Your Order": "Your Order",
        "Your order": "Your order",
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "ascii": "The {attribute} must only contain single-byte alphanumeric characters and symbols.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "array": "The {attribute} must have between {min} and {max} items.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "numeric": "The {attribute} must be between {min} and {max}.",
                "string": "The {attribute} must be between {min} and {max} characters."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "decimal": "The {attribute} must have {decimal} decimal places.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "doesnt_end_with": "The {attribute} may not end with one of the following: {values}.",
            "doesnt_start_with": "The {attribute} may not start with one of the following: {values}.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "enum": "The selected {attribute} is invalid.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field is required.",
            "gt": {
                "array": "The {attribute} must have more than {value} items.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "numeric": "The {attribute} must be greater than {value}.",
                "string": "The {attribute} must be greater than {value} characters."
            },
            "gte": {
                "array": "The {attribute} must have {value} items or more.",
                "file": "The {attribute} must be greater than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be greater than or equal {value}.",
                "string": "The {attribute} must be greater than or equal {value} characters."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lowercase": "The {attribute} must be lowercase.",
            "lt": {
                "array": "The {attribute} must have less than {value} items.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "numeric": "The {attribute} must be less than {value}.",
                "string": "The {attribute} must be less than {value} characters."
            },
            "lte": {
                "array": "The {attribute} must not have more than {value} items.",
                "file": "The {attribute} must be less than or equal {value} kilobytes.",
                "numeric": "The {attribute} must be less than or equal {value}.",
                "string": "The {attribute} must be less than or equal {value} characters."
            },
            "mac_address": "The {attribute} must be a valid MAC address.",
            "max": {
                "array": "The {attribute} may not have more than {max} items.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "numeric": "The {attribute} may not be greater than {max}.",
                "string": "The {attribute} may not be greater than {max} characters."
            },
            "max_digits": "The {attribute} must not have more than {max} digits.",
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "array": "The {attribute} must have at least {min} items.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "numeric": "The {attribute} must be at least {min}.",
                "string": "The {attribute} must be at least {min} characters."
            },
            "min_digits": "The {attribute} must have at least {min} digits.",
            "missing": "The {attribute} field must be missing.",
            "missing_if": "The {attribute} field must be missing when {other} is {value}.",
            "missing_unless": "The {attribute} field must be missing unless {other} is {value}.",
            "missing_with": "The {attribute} field must be missing when {values} is present.",
            "missing_with_all": "The {attribute} field must be missing when {values} are present.",
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": {
                "letters": "The {attribute} must contain at least one letter.",
                "mixed": "The {attribute} must contain at least one uppercase and one lowercase letter.",
                "numbers": "The {attribute} must contain at least one number.",
                "symbols": "The {attribute} must contain at least one symbol.",
                "uncompromised": "The given {attribute} has appeared in a data leak. Please choose a different {attribute}."
            },
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_array_keys": "The {attribute} field must contain entries for: {values}.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_if_accepted": "The {attribute} field is required when {other} is accepted.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "array": "The {attribute} must contain {size} items.",
                "file": "The {attribute} must be {size} kilobytes.",
                "numeric": "The {attribute} must be {size}.",
                "string": "The {attribute} must be {size} characters."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "ulid": "The {attribute} must be a valid ULID.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "uppercase": "The {attribute} must be uppercase.",
            "url": "The {attribute} format is invalid.",
            "uuid": "The {attribute} must be a valid UUID.",
            "attributes": {
                "address": "address",
                "age": "age",
                "amount": "amount",
                "area": "area",
                "available": "available",
                "birthday": "birthday",
                "body": "body",
                "city": "city",
                "content": "content",
                "country": "country",
                "created_at": "created at",
                "creator": "creator",
                "current_password": "current password",
                "date": "date",
                "date_of_birth": "date of birth",
                "day": "day",
                "deleted_at": "deleted at",
                "description": "description",
                "district": "district",
                "duration": "duration",
                "email": "email",
                "excerpt": "excerpt",
                "filter": "filter",
                "first_name": "first name",
                "gender": "gender",
                "group": "group",
                "hour": "hour",
                "image": "image",
                "last_name": "last name",
                "lesson": "lesson",
                "line_address_1": "line address 1",
                "line_address_2": "line address 2",
                "message": "message",
                "middle_name": "middle name",
                "minute": "minute",
                "mobile": "mobile",
                "month": "month",
                "name": "name",
                "national_code": "national code",
                "number": "number",
                "password": "password",
                "password_confirmation": "password confirmation",
                "phone": "phone",
                "photo": "photo",
                "postal_code": "postal code",
                "price": "price",
                "province": "province",
                "recaptcha_response_field": "recaptcha response field",
                "remember": "remember",
                "restored_at": "restored at",
                "result_text_under_image": "result text under image",
                "role": "role",
                "second": "second",
                "sex": "sex",
                "short_text": "short text",
                "size": "size",
                "state": "state",
                "street": "street",
                "student": "student",
                "subject": "subject",
                "teacher": "teacher",
                "terms": "terms",
                "test_description": "test description",
                "test_locale": "test locale",
                "test_name": "test name",
                "text": "text",
                "time": "time",
                "title": "title",
                "updated_at": "updated at",
                "username": "username",
                "year": "year",
                "role_id": "role",
                "shipping_address.street_name": "street name",
                "shipping_address.street_number": "street number",
                "shipping_address.street_number_addition": "street number addition",
                "shipping_address.postcode": "postcode",
                "shipping_address.city": "city",
                "shipping_address.country": "country",
                "billing_address.street_name": "street name",
                "billing_address.street_number": "street number",
                "billing_address.street_number_addition": "street number addition",
                "billing_address.postcode": "postcode",
                "billing_address.city": "city",
                "billing_address.country": "country",
                "shipping_rate_id": "shipping rate",
                "consultant_id": "consultant"
            }
        },
        "http-statuses": {
            "0": "Unknown Error",
            "100": "Continue",
            "101": "Switching Protocols",
            "102": "Processing",
            "200": "OK",
            "201": "Created",
            "202": "Accepted",
            "203": "Non-Authoritative Information",
            "204": "No Content",
            "205": "Reset Content",
            "206": "Partial Content",
            "207": "Multi-Status",
            "208": "Already Reported",
            "226": "IM Used",
            "300": "Multiple Choices",
            "301": "Moved Permanently",
            "302": "Found",
            "303": "See Other",
            "304": "Not Modified",
            "305": "Use Proxy",
            "307": "Temporary Redirect",
            "308": "Permanent Redirect",
            "400": "Bad Request",
            "401": "Unauthorized",
            "402": "Payment Required",
            "403": "Forbidden",
            "404": "Not Found",
            "405": "Method Not Allowed",
            "406": "Not Acceptable",
            "407": "Proxy Authentication Required",
            "408": "Request Timeout",
            "409": "Conflict",
            "410": "Gone",
            "411": "Length Required",
            "412": "Precondition Failed",
            "413": "Payload Too Large",
            "414": "URI Too Long",
            "415": "Unsupported Media Type",
            "416": "Range Not Satisfiable",
            "417": "Expectation Failed",
            "418": "I'm a teapot",
            "419": "Session Has Expired",
            "421": "Misdirected Request",
            "422": "Unprocessable Entity",
            "423": "Locked",
            "424": "Failed Dependency",
            "425": "Too Early",
            "426": "Upgrade Required",
            "428": "Precondition Required",
            "429": "Too Many Requests",
            "431": "Request Header Fields Too Large",
            "444": "Connection Closed Without Response",
            "449": "Retry With",
            "451": "Unavailable For Legal Reasons",
            "499": "Client Closed Request",
            "500": "Internal Server Error",
            "501": "Not Implemented",
            "502": "Bad Gateway",
            "503": "Maintenance Mode",
            "504": "Gateway Timeout",
            "505": "HTTP Version Not Supported",
            "506": "Variant Also Negotiates",
            "507": "Insufficient Storage",
            "508": "Loop Detected",
            "509": "Bandwidth Limit Exceeded",
            "510": "Not Extended",
            "511": "Network Authentication Required",
            "520": "Unknown Error",
            "521": "Web Server is Down",
            "522": "Connection Timed Out",
            "523": "Origin Is Unreachable",
            "524": "A Timeout Occurred",
            "525": "SSL Handshake Failed",
            "526": "Invalid SSL Certificate",
            "527": "Railgun Error",
            "598": "Network Read Timeout Error",
            "599": "Network Connect Timeout Error",
            "unknownError": "Unknown Error"
        },
        "routes": {
            "products": "products",
            "blog": "blog",
            "about-us": "about-us",
            "general-terms": "general-terms",
            "privacy-policy": "privacy-policy",
            "cookie-policy": "cookie-policy",
            "contact": "contact",
            "product": "product",
            "search": "zoeken",
            "video": "video",
            "videos": "videos",
            "horse": "horse",
            "horses": "horses",
            "activities": "activities",
            "activity": "activity",
            "about": "about",
            "trainers": "trainers",
            "people": "people",
            "person": "medewerker",
            "cart": "cart",
            "checkout": "checkout",
            "pricing": "pricing",
            "login": "login",
            "your-videos": "your-videos",
            "all-videos": "all-videos"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We have emailed your password reset link!"
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        }
    },
    "nl": {
        "(and {count} more error)": "(en {count} andere foutmelding)",
        "(and {count} more errors)": "(en {count} andere foutmeldingen)",
        "(copy)": "(kopie)",
        "404 - Page not found": "404 - Pagina niet gevonden",
        "{Attribute} {lang}": "{Attribute} {lang}",
        "{count} characters": "{count} characters",
        "About us": "Over ons",
        "Active": "Actief",
        "Activities": "Activiteiten",
        "Activity": "Activiteit",
        "Activity categories": "Activiteit categorieen",
        "ActivityCategory": "Activiteitcategorie",
        "ActivityCategory Settings": "Activiteit categorie instellingen",
        "Activity Settings": "Activiteit instellingen",
        "Add": "Toevoegen",
        "Add extra": "Extra toevoegen",
        "Add frequently asked question": "Voeg veelgestelde vraag toe",
        "Addition": "Toevoeging",
        "Add link": "Link toevoegen",
        "Add page block": "Pagina blok toevoegen",
        "Add plan": "Abonnement toevoegen",
        "After 30 days it is necessary to activate the two-step verification again": "Na 30 dagen is het nodig om de tweestapsverificatie opnieuw te activeren",
        "All blogs": "Alle blogs",
        "All frequently asked questions": "Alle veelgestelde vragen",
        "All questions": "Alle vragen",
        "All rights reserved.": "Alle rechten voorbehouden.",
        "Amount": "Aantal",
        "Amount of activities": "Aantal activiteiten",
        "Amount of products": "Aantal producten",
        "Amount of videos": "Aantal videos",
        "Answer": "Antwoord",
        "A piece": "Per stuk",
        "Apply discount code": "Kies kortingscode",
        "Author": "Auteur",
        "Avatar": "Avatar",
        "Back": "Terug",
        "Background color": "Achtergrondkleur",
        "Back to home": "Terug naar home",
        "Banner": "Banner",
        "Billing address": "Facturatie adres",
        "Blog": "Blog",
        "Blog cta": "Blog cta",
        "Blog overview": "Blog overzicht",
        "Blogs": "Blog",
        "Blog Settings": "Blog instellingen",
        "Button link": "Knop link",
        "Buttons": "Knoppen",
        "Button text": "Knop label",
        "Capacities": "Capaciteiten",
        "Capacity": "Capaciteit",
        "Categories": "Categorieën",
        "Category": "Categorie",
        "Category Settings": "Categorie instellingen",
        "Change": "Wijzig",
        "Checkout": "Bestel",
        "City": "Stad",
        "Code": "Code",
        "Company details": "Bedrijfsinstellingen",
        "Company name": "Bedrijfsnaam",
        "Complete": "Voltooi",
        "Completed": "Voltooid",
        "Concept": "Concept",
        "Concept in only visible to logged in users, draft is not visible to anyone": "Concept in alleen zichtbaar voor ingelogde gebruikers, draft is voor niemand zichtbaar",
        "Confirmation {source}": "Bevestiging {source}",
        "Confirm password": "Bevestig wachtwoord",
        "Contact": "Contact",
        "Contact Form": "Contactformulier",
        "Contact form": "Contactformulier",
        "Contacts": "Contacten",
        "Content": "Inhoud",
        "Coupon applied": "Coupon verwerkt",
        "Coupon can no longer be used": "Coupon kan niet langer worden gebruikt",
        "Coupon not found": "Coupon niet gevonden",
        "Coupons": "Kortingscodes",
        "Create a password": "Maak een wachtwoord aan",
        "Created at": "Gemaakt op",
        "Create your Fair To Horses account": "Maak je Fair to Horses account",
        "CTA Banner": "CTA-banner",
        "Custom": "Aangepast",
        "Custom video preview": "Aangepast video voorbeeld",
        "Delete": "Verwijder",
        "Description": "Beschrijving",
        "description": "beschrijving",
        "Discount": "Korting",
        "Discount active": "Korting actief",
        "Discount code": "Kortingscode",
        "Discount key": "Kortingscode",
        "Down": "Omlaag",
        "Draft": "Voorlopige versie",
        "E-mail": "E-mail",
        "Email": "E-mail",
        "Email address": "E-mailadres",
        "End": "Einde",
        "End date": "Einddatum",
        "Enter one of the recovery codes here": "Voer hier een van de herstelcodes in",
        "Enter the 6-digit code here": "Voer de 6 cijferige code in",
        "Excerpt": "Uittreksel",
        "excerpt": "uittreksel",
        "Extra bookings": "Extra boekingen",
        "Extra opties": "Extra opties",
        "Extra options": "Extra opties",
        "Extras": "Extras",
        "Extras description": "Extras beschrijving",
        "Extras title": "Extras titel",
        "Faq": "Veelgestelde vraag",
        "Faq Index": "Faq Index",
        "Faqs": "Veelgestelde vragen",
        "Features": "Inhoud",
        "Filter": "Filter",
        "First name": "Voornaam",
        "Forbidden": "Geen toegang",
        "Forgot password": "Wachtwoord vergeten",
        "Forgot password?": "Wachtwoord vergeten?",
        "Forgot your password? Send a password reset link": "Wachtwoord vergeten? Verstuur een reset link",
        "Function": "Functie",
        "Gallery": "Galerie",
        "General": "Algemeen",
        "Generic": "Algemeen",
        "Google Maps URL": "Google Maps URL",
        "Google maps URL": "Google maps URL",
        "Go to page {page}": "Ga naar pagina {page}",
        "Hello!": "Hallo!",
        "Highlighted pages": "Uitgelichten pagina's",
        "Hits": "Hits",
        "Home Banner": "Homepage Banner",
        "Horse": "Paard",
        "Horse categories": "Paard categorieen",
        "HorseCategory": "Paard categorie",
        "HorseCategory Settings": "Paard categorie instellingen",
        "Horses": "Paarden",
        "Horse Settings": "Paard instellingen",
        "I agree with the terms and conditions and have checked my order and details *": "Ik ga akkoord met de voorwaarden en heb mijn bestelling en gegevens gecontroleerd *",
        "If enabled, and no image is uploaded, the banner from the homepage will be shown.": "Indien ingeschakeld, en er is geen afbeelding geupload, dan wordt de banner van de homepage getoond.",
        "If left empty, the page title will be used.": "Indien leeg gelaten, wordt de paginatitel gebruikt.",
        "If left empty, the title will be used.": "Indien leeg gelaten, wordt de titel gebruikt.",
        "If you're having trouble clicking the \"{actionText}\" button, copy and paste the URL belowninto your web browser:": "Als je problemen hebt met de \"{actionText}\" knop, kopieer en plak de URL hierondernin je webbrowser:",
        "If you did not create an account, no further action is required.": "Als je geen account hebt aangemaakt hoef je verder niets te doen.",
        "If you did not request a password reset, no further action is required.": "Als je geen wachtwoordherstel hebt aangevraagd, hoef je verder niets te doen.",
        "I have a discount": "Ik heb een kortingscode",
        "Image": "Afbeelding",
        "Image + Text": "Afbeelding + tekst",
        "Image left": "Afbeelding links",
        "Image right": "Afbeelding rechts",
        "Including VAT": "Inclusief BTW",
        "Index Page": "Index pagina",
        "Initial": "Initieel",
        "Introduction": "Inleiding",
        "Invoice address (Optional)": "Factuuradres (Optioneel)",
        "It is recommended to keep the {attribute} between {min} and {max} characters long": "Het wordt aanbevolen het {attribute} tussen {min} en {max} tekens lang te houden.",
        "I would like to receive a newsletter from Fair to Horses.": "Ik wil graag een nieuwsbrief ontvangen van Fair to Horses.",
        "Kind regards,": "Met vriendelijke groet,",
        "Last name": "Achternaam",
        "Latest orders": "Laatste bestellingen",
        "Layout": "Lay-out",
        "Leave empty for no end date": "Leeg laten voor geen einddatum",
        "Leave empty to use parent details": "Leeg laten om hoofdgegevens te gebruiken",
        "Link list": "Link lijst",
        "Login": "Inloggen",
        "Login to checkout": "Log in om af te rekenen",
        "Login to your account in our secure environment": "Log in op uw account in onze beveiligde omgeving",
        "Logout": "Uitloggen",
        "Made by:": "Gerealiseerd door:",
        "Make your decision:": "Maak je keuze:",
        "Message": "Bericht",
        "More settings can be set in the Page Block Settings page": "Meer instellingen kunnen worden ingesteld op de pagina Instellingen paginablok",
        "Name": "Naam",
        "name": "naam",
        "Newsletter": "Nieuwsbrief",
        "New URL": "Nieuwe URL",
        "Next": "Volgende",
        "No products in shopping cart": "Geen producten in je winkelwagen",
        "Not available in this combination": "Niet beschikbaar in deze combinatie",
        "Not Found": "Niet gevonden",
        "Number": "Nummer",
        "of": "van",
        "Old URL": "Oude URL",
        "Openings hours": "Openingstijden",
        "Open the authenticator app on your phone and enter the code here": "Open de authenticator app op je telefoon en vul hier de code in",
        "Order": "Bestel",
        "Order now": "Bestel direct",
        "Order number": "Bestellingsnummer",
        "Orders": "Bestellingen",
        "Overview": "Overzicht",
        "Package": "Pakket",
        "Page": "Pagina",
        "Page blocks": "Pagina blokken",
        "Page Content": "Pagina inhoud",
        "Page Expired": "Pagina niet meer geldig",
        "Pages": "Paginas",
        "Page Title": "Page Title",
        "Pagination Navigation": "Paginanavigatie",
        "Paid": "Betaald",
        "paid": "Betaald",
        "Parent category": "Hoofdcategorie",
        "Password": "Wachtwoord",
        "Password reset": "Wachtwoord reset",
        "Password reset link has been sent": "Wachtwoord reset link is verstuurd",
        "Payment Required": "Betaling Vereist",
        "Payments": "Betalingen",
        "People": "Medewerkers",
        "Permanent": "Permanent",
        "Person": "Medewerker",
        "Person categories": "Medewerker categorieen",
        "PersonCategory": "Medewerker categorie",
        "PersonCategory Settings": "Medewerker instellingen",
        "Person Settings": "Medewerker instellingen",
        "Phone": "Telefoon",
        "Phone number": "Telefoonnummer",
        "Plans": "Abonnementen",
        "Please click the button below to verify your email address.": "Klik op de knop hieronder om je e-mailadres te verifiëren.",
        "Postal code": "Postcode",
        "Postalcode": "Postcode",
        "Postcode": "Postcode",
        "Previous": "Vorige",
        "Price": "Prijs",
        "Price annual": "Prijs per kwartaal",
        "Price annual monthly": "Prijs per kwartaal - Maandelijks",
        "Price half year": "Prijs per half jaar",
        "Price half year monthly": "Prijs per half jaar - Maandelijks",
        "Price yearly": "Prijs per jaar",
        "Price yearly monthly": "Prijs per jaar - Maandelijks",
        "Pricing header": "Tarieven header",
        "Primary (dark green)": "Primair (donkergroen)",
        "Primary type": "Primair type",
        "Privacy declaration": "Privacyverklaring",
        "Product": "Product",
        "Products": "Producten",
        "Published": "Gepubliceerd",
        "Published at": "Gepubliceerd op",
        "Published Date": "Gepubliceerd op",
        "Quantity": "Aantal",
        "Question": "Vraag",
        "Read more": "Lees meer",
        "Regards": "Met vriendelijke groet",
        "Register": "Registreren",
        "Register to your account in our secure environment": "Registreer u op uw account in onze beveiligde omgeving",
        "Remark": "Opmerking",
        "Remove discount code": "Verwijder kortingscode",
        "Reset Password": "Wachtwoord herstellen",
        "Reset password": "Reset wachtwoord",
        "Reset Password Notification": "Wachtwoordherstel notificatie",
        "Reset your password": "Reset je wachtwoord",
        "results": "resultaten",
        "Roles": "Rollen",
        "Same address": "Zelfde adres",
        "Scope": "Toepassingsgebied",
        "Secondary (beige)": "Secundair (beige)",
        "Secondary button link": "Secundaire knoplink",
        "Secondary button text": "Secundaire knop tekst",
        "Secondary dark (brown)": "Secundair donker (bruin)",
        "Secure video": "Beveiligde video",
        "Select": "Selecteer",
        "Select a template to add the corresponding blocks. Note that this cannot be changed after page has been created": "Selecteer een template om de bijbehorende blokken toe te voegen. Let op: dit kan niet worden gewijzigd nadat de pagina is aangemaakt.",
        "Send": "Verstuur",
        "Send a password reset link": "Verstuur een wachtwoord reset link",
        "Send email": "Stuur e-mail",
        "Send link": "Verstuur link",
        "Sent at": "Verzonden op",
        "Seo Settings": "Seo instellingen",
        "SEO Settings for {lang}": "SEO instellingen voor {lang}",
        "SEO title": "SEO titel",
        "Server Error": "Server fout",
        "Services": "Diensten",
        "Service Unavailable": "Website onbeschikbaar",
        "Setting": "Instellingen",
        "Settings": "Instellingen",
        "Shipping address": "Afleveradres",
        "Shipping address same as billing address": "Adres is hetzelfde als het factuuradres",
        "Shipping method": "Verzendmethode",
        "Shipping rates": "Verzendkosten",
        "Shop": "Winkel",
        "Short title (1-2 words) for the thumbnail": "Korte titel (1-2 woorden) voor de thumbnail",
        "Showing": "Toont",
        "Slug": "Permalink",
        "Social media": "Sociale media",
        "Start": "Start",
        "Start date": "Startdatum",
        "Status": "Status",
        "Street name": "Straatnaam",
        "Street number": "Straatnummer",
        "Street number addition": "Straatnummer toevoeging",
        "Subject": "Onderwerp",
        "Subtitle": "Ondertitel",
        "Subtotal": "Subtotaal",
        "Tags": "Tags",
        "Tax": "BTW",
        "Terms and Conditions": "Algemene Voorwaarden",
        "Text": "Tekst",
        "Thank you for your message.": "Bedankt voor je bericht",
        "The {attribute} must contain at least one letter.": "Het {attribute} moet minimaal één letter bevatten.",
        "The {attribute} must contain at least one number.": "Het {attribute} moet minimaal één cijfer bevatten.",
        "The {attribute} must contain at least one symbol.": "Het {attribute} moet minimaal één symbool bevatten.",
        "The {attribute} must contain at least one uppercase and one lowercase letter.": "Het {attribute} moet minimaal één hoofdletter en één kleine letter bevatten.",
        "The coupon has already been used.": "Deze code is al gebruikt",
        "The coupon has expired.": "Kortingscode is verlopen",
        "The given {attribute} has appeared in a data leak. Please choose a different {attribute}.": "Het {attribute} is aangetroffen in een datalek. Geef een ander {attribute}.",
        "The given data was invalid.": "De gegeven data was ongeldig.",
        "The provided password does not match your current password.": "Het opgegeven wachtwoord komt niet overeen met uw huidige wachtwoord.",
        "This link expires in {number} hours": "Deze link verloopt over {number} uur",
        "This password reset link will expire in {count} minutes.": "Deze link om je wachtwoord te herstellen verloopt over {count} minuten.",
        "Title": "Titel",
        "title": "titel",
        "Title override": "Titel overschrijven",
        "to": "tot",
        "Toggle navigation": "Schakel navigatie",
        "Too Many Requests": "Te veel serververzoeken",
        "Total": "Totaal",
        "Total quantity": "Totaal aantal",
        "Trainer": "Ruiter",
        "Trainers": "Trainers",
        "Trainer Settings": "Ruiter instellingen",
        "Two factor challenge": "Twee-factor uitdaging",
        "Type": "Type",
        "Unauthorized": "Onbevoegd",
        "Unavailable code": "Code niet beschikbaar",
        "Up": "Omhoog",
        "Upcoming activities": "Aankomende activiteiten",
        "url": "url",
        "Use an authentication code": "Gebruik authenticator code",
        "Use a recovery code": "Gebruik een herstelcode",
        "User": "Gebruiker",
        "Users": "Gebruikers",
        "Uw winkelmand is leeg": "Uw winkelmand is leeg.",
        "Variant": "Optie",
        "Variants": "Varianten",
        "VAT": "BTW",
        "Verify and login": "Verifeer en login",
        "Verify Email Address": "Verifieer e-mailadres",
        "Video": "Video",
        "Videos": "Videos",
        "Was unable to find an address with this postcode and street number": "Kon geen adres vinden met deze postcode en huisnummer",
        "Website": "Website",
        "We have done our best, but it seems that the page you requested does not exist (anymore) or that it may have moved.": "We hebben ons best gedaan, maar het lijkt erop dat de door u opgevraagde pagina niet (meer) bestaat of dat deze is verplaatst.",
        "When enabled, an email will be sent to the user, letting them know their account has been created.": "Indien ingeschakeld, wordt een e-mail naar de gebruiker gestuurd om hem te laten weten dat zijn account is aangemaakt.",
        "White": "Wit",
        "Whoops!": "Oeps!",
        "You are receiving this email because we received a password reset request for your account.": "Je ontvangt deze e-mail omdat we een wachtwoordherstel verzoek hebben ontvangen voor je account.",
        "Your account for {siteName}": "Je account voor {siteName}",
        "Your cart is empty": "Je winkelwagen is leeg",
        "Your Order": "Jouw bestelling",
        "Your order": "Jouw bestelling",
        "You will receive this email because your account is ready for {siteName}": "Je ontvangt deze e-mail omdat je account klaar is voor {siteName}",
        "auth": {
            "failed": "Deze combinatie van e-mailadres en wachtwoord is niet geldig.",
            "password": "Wachtwoord is onjuist.",
            "throttle": "Te veel mislukte aanmeldpogingen. Probeer het nog eens over {seconds} seconden."
        },
        "validation": {
            "accepted": "{Attribute} moet worden geaccepteerd.",
            "accepted_if": "{Attribute} moet worden geaccepteerd als {other} {value} is.",
            "active_url": "{Attribute} is geen geldige URL.",
            "after": "{Attribute} moet een datum na {date} zijn.",
            "after_or_equal": "{Attribute} moet een datum na of gelijk aan {date} zijn.",
            "alpha": "{Attribute} mag alleen letters bevatten.",
            "alpha_dash": "{Attribute} mag alleen letters, nummers, underscores (_) en streepjes (-) bevatten.",
            "alpha_num": "{Attribute} mag alleen letters en nummers bevatten.",
            "array": "{Attribute} moet geselecteerde elementen bevatten.",
            "ascii": "De {attribute} mag alleen alfanumerieke tekens en symbolen van één byte bevatten.",
            "before": "{Attribute} moet een datum vóór {date} zijn.",
            "before_or_equal": "{Attribute} moet een datum vóór of gelijk aan {date} zijn.",
            "between": {
                "array": "{Attribute} moet tussen {min} en {max} waardes bevatten.",
                "file": "{Attribute} moet tussen {min} en {max} kilobytes zijn.",
                "numeric": "{Attribute} moet tussen {min} en {max} zijn.",
                "string": "{Attribute} moet tussen {min} en {max} karakters zijn."
            },
            "boolean": "{Attribute} moet ja of nee zijn.",
            "confirmed": "Bevestiging van {attribute} komt niet overeen.",
            "current_password": "Huidig wachtwoord is onjuist.",
            "date": "{Attribute} moet een datum bevatten.",
            "date_equals": "{Attribute} moet een datum gelijk aan {date} zijn.",
            "date_format": "{Attribute} voldoet niet aan het formaat {format}.",
            "decimal": "De {attribute} moet {decimal} decimalen hebben.",
            "declined": "{Attribute} moet afgewezen worden.",
            "declined_if": "{Attribute} moet afgewezen worden wanneer {other} gelijk is aan {value}.",
            "different": "{Attribute} en {other} moeten verschillend zijn.",
            "digits": "{Attribute} moet bestaan uit {digits} cijfers.",
            "digits_between": "{Attribute} moet bestaan uit minimaal {min} en maximaal {max} cijfers.",
            "dimensions": "{Attribute} heeft geen geldige afmetingen.",
            "distinct": "{Attribute} heeft een dubbele waarde.",
            "doesnt_end_with": "{Attribute} mag niet eindigen met één van de volgende waarden: {values}.",
            "doesnt_start_with": "{Attribute} mag niet beginnen met één van de volgende waarden: {values}.",
            "email": "{Attribute} is geen geldig e-mailadres.",
            "ends_with": "{Attribute} moet met één van de volgende waarden eindigen: {values}.",
            "enum": "Gekozen {attribute} is ongeldig.",
            "exists": "{Attribute} bestaat niet.",
            "file": "{Attribute} moet een bestand zijn.",
            "filled": "{Attribute} is verplicht.",
            "gt": {
                "array": "{Attribute} moet meer dan {value} waardes bevatten.",
                "file": "{Attribute} moet groter zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet groter zijn dan {value}.",
                "string": "{Attribute} moet meer dan {value} tekens bevatten."
            },
            "gte": {
                "array": "{Attribute} moet {value} of meer waardes bevatten.",
                "file": "{Attribute} moet groter of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet groter of gelijk zijn aan {value}.",
                "string": "{Attribute} moet minimaal {value} tekens bevatten."
            },
            "image": "{Attribute} moet een afbeelding zijn.",
            "in": "{Attribute} is ongeldig.",
            "in_array": "{Attribute} bestaat niet in {other}.",
            "integer": "{Attribute} moet een getal zijn.",
            "ip": "{Attribute} moet een geldig IP-adres zijn.",
            "ipv4": "{Attribute} moet een geldig IPv4-adres zijn.",
            "ipv6": "{Attribute} moet een geldig IPv6-adres zijn.",
            "json": "{Attribute} moet een geldige JSON-string zijn.",
            "lowercase": "{Attribute} mag alleen kleine letters bevatten.",
            "lt": {
                "array": "{Attribute} moet minder dan {value} waardes bevatten.",
                "file": "{Attribute} moet kleiner zijn dan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner zijn dan {value}.",
                "string": "{Attribute} moet minder dan {value} tekens bevatten."
            },
            "lte": {
                "array": "{Attribute} moet {value} of minder waardes bevatten.",
                "file": "{Attribute} moet kleiner of gelijk zijn aan {value} kilobytes.",
                "numeric": "{Attribute} moet kleiner of gelijk zijn aan {value}.",
                "string": "{Attribute} moet maximaal {value} tekens bevatten."
            },
            "mac_address": "{Attribute} moet een geldig MAC-adres zijn.",
            "max": {
                "array": "{Attribute} mag niet meer dan {max} waardes bevatten.",
                "file": "{Attribute} mag niet meer dan {max} kilobytes zijn.",
                "numeric": "{Attribute} mag niet hoger dan {max} zijn.",
                "string": "{Attribute} mag niet uit meer dan {max} tekens bestaan."
            },
            "max_digits": "{Attribute} mag niet uit meer dan {max} cijfers bestaan.",
            "mimes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "mimetypes": "{Attribute} moet een bestand zijn van het bestandstype {values}.",
            "min": {
                "array": "{Attribute} moet minimaal {min} waardes bevatten.",
                "file": "{Attribute} moet minimaal {min} kilobytes zijn.",
                "numeric": "{Attribute} moet minimaal {min} zijn.",
                "string": "{Attribute} moet minimaal {min} tekens zijn."
            },
            "min_digits": "{Attribute} moet minimaal uit {min} cijfers bestaan.",
            "missing": "Het veld {attribute} moet ontbreken.",
            "missing_if": "Het veld {attribute} moet ontbreken als {other} {value} is.",
            "missing_unless": "Het veld {attribute} moet ontbreken, tenzij {other} {value} is.",
            "missing_with": "Het veld {attribute} moet ontbreken wanneer {values} aanwezig is.",
            "missing_with_all": "Het veld {attribute} moet ontbreken wanneer er {values} aanwezig zijn.",
            "multiple_of": "{Attribute} moet een veelvoud van {value} zijn.",
            "not_in": "{Attribute} is ongeldig.",
            "not_regex": "Het formaat van {attribute} is ongeldig.",
            "numeric": "{Attribute} moet een getal zijn.",
            "password": {
                "letters": "{Attribute} moet minimaal één letter bevatten.",
                "mixed": "{Attribute} moet minimaal één kleine letter en één hoofdletter bevatten.",
                "numbers": "{Attribute} moet minimaal één cijfer bevatten.",
                "symbols": "{Attribute} moet minimaal één vreemd teken bevatten.",
                "uncompromised": "Het opgegeven {attribute} komt voor in een datalek. Kies een ander {attribute}."
            },
            "present": "{Attribute} moet aanwezig zijn.",
            "prohibited": "{Attribute} is niet toegestaan.",
            "prohibited_if": "{Attribute} is niet toegestaan indien {other} gelijk is aan {value}.",
            "prohibited_unless": "{Attribute} is niet toegestaan tenzij {other} gelijk is aan {values}.",
            "prohibits": "{Attribute} is niet toegestaan in combinatie met {other}.",
            "regex": "Het formaat van {attribute} is ongeldig.",
            "required": "{Attribute} is verplicht.",
            "required_array_keys": "{Attribute} moet waardes bevatten voor {values}.",
            "required_if": "{Attribute} is verplicht indien {other} gelijk is aan {value}.",
            "required_if_accepted": "{Attribute} is verplicht indien {other} is geaccepteerd.",
            "required_unless": "{Attribute} is verplicht tenzij {other} gelijk is aan {values}.",
            "required_with": "{Attribute} is verplicht in combinatie met {values}.",
            "required_with_all": "{Attribute} is verplicht in combinatie met {values}.",
            "required_without": "{Attribute} is verplicht als {values} niet ingevuld is.",
            "required_without_all": "{Attribute} is verplicht als {values} niet ingevuld zijn.",
            "same": "{Attribute} en {other} moeten overeenkomen.",
            "size": {
                "array": "{Attribute} moet {size} waardes bevatten.",
                "file": "{Attribute} moet {size} kilobytes groot zijn.",
                "numeric": "{Attribute} moet {size} zijn.",
                "string": "{Attribute} moet {size} tekens zijn."
            },
            "starts_with": "{Attribute} moet beginnen met een van de volgende: {values}.",
            "string": "{Attribute} moet een tekst zijn.",
            "timezone": "{Attribute} moet een geldige tijdzone zijn.",
            "ulid": "De {attribute} moet een geldige ULID zijn.",
            "unique": "{Attribute} is al in gebruik.",
            "uploaded": "Het uploaden van {attribute} is mislukt.",
            "uppercase": "{Attribute} mag alleen hoofdletters bevatten.",
            "url": "{Attribute} moet een geldige URL zijn.",
            "uuid": "{Attribute} moet een geldige UUID zijn.",
            "attributes": {
                "address": "adres",
                "age": "leeftijd",
                "amount": "bedrag",
                "area": "regio",
                "available": "beschikbaar",
                "birthday": "verjaardag",
                "body": "body",
                "city": "stad",
                "content": "inhoud",
                "country": "land",
                "created_at": "aangemaakt op",
                "creator": "maker",
                "current_password": "huidig wachtwoord",
                "date": "datum",
                "date_of_birth": "geboortedatum",
                "day": "dag",
                "deleted_at": "verwijderd op",
                "description": "omschrijving",
                "district": "wijk",
                "duration": "tijdsduur",
                "email": "e-mailadres",
                "excerpt": "uittreksel",
                "filter": "filter",
                "first_name": "voornaam",
                "gender": "geslacht",
                "group": "groep",
                "hour": "uur",
                "image": "afbeelding",
                "last_name": "achternaam",
                "lesson": "les",
                "line_address_1": "adresregel 1",
                "line_address_2": "adresregel 2",
                "message": "bericht",
                "middle_name": "tweede naam",
                "minute": "minuut",
                "mobile": "mobiel",
                "month": "maand",
                "name": "naam",
                "national_code": "landcode",
                "number": "nummer",
                "password": "wachtwoord",
                "password_confirmation": "wachtwoordbevestiging",
                "phone": "telefoonnummer",
                "photo": "foto",
                "postal_code": "postcode",
                "price": "prijs",
                "province": "provincie",
                "recaptcha_response_field": "recaptcha antwoordveld",
                "remember": "onthouden",
                "restored_at": "hersteld op",
                "result_text_under_image": "antwoord tekst onder afbeelding",
                "role": "rol",
                "second": "seconde",
                "sex": "geslacht",
                "short_text": "korte tekst",
                "size": "grootte",
                "state": "staat",
                "street": "straatnaam",
                "student": "student",
                "subject": "onderwerp",
                "teacher": "docent",
                "terms": "voorwaarden",
                "test_description": "test beschrijving",
                "test_locale": "test landinstelling",
                "test_name": "test naam",
                "text": "tekst",
                "time": "tijd",
                "title": "titel",
                "updated_at": "bijgewerkt op",
                "username": "gebruikersnaam",
                "year": "jaar",
                "role_id": "rol",
                "user_id": "gebruiker",
                "user_type": "gebruikerstype",
                "shipping_address.street_name": "Straatnaam",
                "shipping_address.street_number": "Huisnummer",
                "shipping_address.street_number_addition": "Toevoeging",
                "shipping_address.postcode": "Postcode",
                "shipping_address.city": "Plaats",
                "billing_address.street_name": "Straatnaam",
                "billing_address.street_number": "Huisnummer",
                "billing_address.street_number_addition": "Toevoeging",
                "billing_address.postcode": "Postcode",
                "billing_address.city": "Plaats",
                "billing_address.country": "Land",
                "billing_address.vat_number": "BTW nummer",
                "billing_address.company_name": "Bedrijfsnaam",
                "shipping_rate_id": "Verzendmethode",
                "consultant_id": "Consultant",
                "terms_and_conditions": "Algemene voorwaarden en privacy verklaring"
            }
        },
        "http-statuses": {
            "0": "Onbekende foutmelding",
            "100": "Doorgaan",
            "101": "Protocolwissel",
            "102": "Verwerken",
            "200": "Oké",
            "201": "Aangemaakt",
            "202": "Aanvaard",
            "203": "Niet-gemachtigde informatie",
            "204": "Geen inhoud",
            "205": "Inhoud opnieuw instellen",
            "206": "Gedeeltelijke inhoud",
            "207": "Meerdere statussen",
            "208": "Al gemeld",
            "226": "Ik ben gebruikt",
            "300": "Meerkeuze",
            "301": "Definitief verplaatst",
            "302": "Gevonden",
            "303": "Zie andere",
            "304": "Niet gewijzigd",
            "305": "Gebruik Proxy",
            "307": "Tijdelijke omleiding",
            "308": "Definitieve omleiding",
            "400": "Foute aanvraag",
            "401": "Niet geautoriseerd",
            "402": "Betaalde toegang",
            "403": "Verboden toegang",
            "404": "Niet gevonden",
            "405": "Methode niet toegestaan",
            "406": "Niet aanvaardbaar",
            "407": "Authenticatie op de proxyserver verplicht",
            "408": "Aanvraagtijd verstreken",
            "409": "Conflict",
            "410": "Verdwenen",
            "411": "Lengte vereist",
            "412": "Niet voldaan aan de vooraf gestelde voorwaarde",
            "413": "Aanvraag te groot",
            "414": "Aanvraag-URL te lang",
            "415": "Media-type niet ondersteund",
            "416": "Bereik niet bevredigend",
            "417": "Niet voldaan aan verwachting",
            "418": "Ik ben een theepot",
            "419": "Pagina verlopen",
            "421": "Verkeerd geadresseerd verzoek",
            "422": "Aanvraag kan niet worden verwerkt",
            "423": "Afgesloten",
            "424": "Gefaalde afhankelijkheid",
            "425": "Te vroeg",
            "426": "Upgrade nodig",
            "428": "Voorwaarde nodig",
            "429": "Te veel requests",
            "431": "Headers van de aanvraag te lang",
            "444": "Verbinding gesloten zonder reactie",
            "449": "Opnieuw proberen met",
            "451": "Toegang geweigerd om juridische redenen",
            "499": "Klant Gesloten Verzoek",
            "500": "Interne serverfout",
            "501": "Niet geïmplementeerd",
            "502": "Slechte poort",
            "503": "Dienst niet beschikbaar",
            "504": "Gateway-time-out",
            "505": "HTTP-versie wordt niet ondersteund",
            "506": "Variant onderhandelt ook",
            "507": "Onvoldoende opslag",
            "508": "Loop gedetecteerd",
            "509": "Bandbreedte overschreden",
            "510": "Niet verlengd",
            "511": "Netwerkauthenticatie vereist",
            "520": "Onbekende foutmelding",
            "521": "Webserver is onbereikbaar",
            "522": "Connectie duurt te lang",
            "523": "Herkomst is onbereikbaar",
            "524": "Time-out opgetreden",
            "525": "SSL-handshake mislukt",
            "526": "Ongeldig SSL-certificaat",
            "527": "Railgun foutmelding",
            "598": "Time-outfout netwerk lezen",
            "599": "Fout bij time-out netwerkverbinding",
            "unknownError": "Onbekende foutmelding"
        },
        "routes": {
            "products": "producten",
            "frequently-asked-questions": "veelgestelde-vragen",
            "blog": "blog",
            "about-us": "over-ons",
            "general-terms": "algemene-voorwaarden",
            "product": "product",
            "privacy-policy": "privacy-beleid",
            "cookie-policy": "cookie-beleid",
            "contact": "contact",
            "search": "zoeken",
            "video": "video",
            "videos": "videos",
            "horse": "paard",
            "horses": "paarden",
            "activities": "activiteiten",
            "activity": "activiteit",
            "about": "over-ons",
            "trainers": "trainers",
            "people": "medewerkers",
            "person": "medewerker",
            "cart": "winkelwagen",
            "checkout": "afrekenen",
            "pricing": "tarieven",
            "login": "inloggen",
            "your-videos": "jouw-videos",
            "all-videos": "alle-videos"
        },
        "passwords": {
            "reset": "Het wachtwoord van uw account is gewijzigd.",
            "sent": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen.",
            "throttled": "Gelieve even te wachten en het dan opnieuw te proberen.",
            "token": "Dit wachtwoordhersteltoken is niet geldig.",
            "user": "We hebben een e-mail verstuurd met instructies om een nieuw wachtwoord in te stellen."
        },
        "pagination": {
            "next": "Volgende &raquo;",
            "previous": "&laquo; Vorige"
        }
    }
}
